var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Accessibility'),_c('NavBar'),_c('main',{attrs:{"tabindex":"-1","role":"main"}},[_c('Hero'),_c('Impact'),_c('Social'),_c('Video'),_c('Manulife'),_c('Foot')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }